import { isArray, isObject } from "lodash";
import { ALERT_TYPE_LABELS } from "../constants/alertTypes";

export const formatUsers = (data) => {
  if (!data) {
    return [];
  }
  if (isArray(data)) {
    return data.map((data) => ({
      ...data,
      label: `${data.name} ${data.surname}`,
      value: data._id
    }));
  }
  if (isObject(data)) {
    return {
      ...data,
      value: data._id,
      label: `${data.name} ${data.surname}`
    };
  }
};

export const formatAlerts = (data) => {
  if (!data) {
    return [];
  }
  const labelFor = (row) =>
    ALERT_TYPE_LABELS[row.alertType] || row.name || row.title || "";
  if (isArray(data)) {
    return data.map((data) => ({
      ...data,
      label: labelFor(data),
      value: data._id,
    }));
  }
  if (isObject(data)) {
    return {
      ...data,
      value: data._id,
      label: labelFor(data),
    };
  }
};
